import useCurrentBreakpoint from '@britishcouncil/react-extro-ui/dist/hooks/useCurrentBreakpoint';
import { TimerSectionProps } from '../../..';
import { TimerSection } from '../../../timer';
import * as S from './CommonInstalmentPlanSideSection.styles';
import InstalmentsSummary, {
  InstalmentsSummaryProps,
} from '../../../summary/instalmentsSummary/InstalmentsSummary';
import ErrorSummaryMessage from '../../../errorSummary/ErrorSummaryMessage';
import { useErrorSummaryContext } from '../../../../contexts';

interface CommonInstalmentPlanSideSectionProps {
  timer?: TimerSectionProps;
  instalmentsSummary?: InstalmentsSummaryProps;
  isUpdatingPaymentMethod?: boolean;
}

const CommonInstalmentPlanSideSection = ({
  timer,
  instalmentsSummary,
  isUpdatingPaymentMethod,
}: CommonInstalmentPlanSideSectionProps) => {
  const breakpoint = useCurrentBreakpoint();
  const { isErrorSummaryMessageVisible } = useErrorSummaryContext();

  if (breakpoint === 'lg') {
    return (
      <S.StickyRoot className="sticky">
        {isErrorSummaryMessageVisible && <ErrorSummaryMessage />}
        {timer && <TimerSection {...timer} />}
        {instalmentsSummary && (
          <InstalmentsSummary
            {...instalmentsSummary}
            isUpdatingPaymentMethod={isUpdatingPaymentMethod}
          />
        )}
      </S.StickyRoot>
    );
  }

  return (
    <>
      <S.StickyRoot className="sticky">
        {isErrorSummaryMessageVisible && <ErrorSummaryMessage />}
        {timer && <TimerSection {...timer} />}
      </S.StickyRoot>
      <S.Root>
        {instalmentsSummary && (
          <InstalmentsSummary
            {...instalmentsSummary}
            isUpdatingPaymentMethod={isUpdatingPaymentMethod}
          />
        )}
      </S.Root>
    </>
  );
};

export default CommonInstalmentPlanSideSection;
